export default "__VITE_ASSET__f7a43366__"